import React from "react";
import { Control, Controller } from "react-hook-form";
import { isNumber, isString, toNumber } from "lodash";
import Label from "components/shared/form/Label";
import Hint from "components/shared/form/fields/Hint";

function round(value: number, precision = 0) {
  if (isNumber(value)) return value.toFixed(precision);
  if (isString(value)) return Number.parseFloat(value).toFixed(precision);

  return value;
}

type NumberFieldArgs = {
  name: string;
  precision?: number;
  label?: string;
  control?: Control<any>;
  required?: boolean;
  hint?: string;
  min?: number;
  max?: number;
};

export default function NumberField({
  precision,
  name,
  required,
  control,
  label,
  hint,
  ...inputProps
}: NumberFieldArgs) {
  return (
    <div className="control-group">
      {label && <Label label={label} />}
      <div className="controls">
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <input
              type="number"
              {...inputProps}
              {...field}
              onBlur={(e) => {
                field.onChange(round(toNumber(e.target.value), precision));
                field.onBlur();
              }}
            />
          )}
          rules={{ required }}
        />
      </div>
      {hint && <Hint text={hint} />}
    </div>
  );
}
